<template>
  <LoadingWrapper dir="rtl" :loading="loading" class="search">

    <FloatingBarComponent v-if="this.floatingBarData" :content="this.floatingBarData"  />
    <div v-if="data?.search_popup_link" style="display:none" id="searchPopupLink" :url="data.search_popup_link.href" />

    <div v-if="data?.selectors?.form">

      <HorizontalScrollContainer v-if="data?.selectors.form.top_line.fields" class="margin-lr--20 dmargin-lr-0 padding-tb-10 bg-f3" >
        <div class="w-auto btn first-btn-wrapper f13-l16-l df16-l20 position-relative" v-for="option in data.selectors.form.top_line.fields[0].options" :key="option.val">
          <input type="checkbox" name="f0" class="btn-check" autocomplete="off" :value="option.value" v-model="selector0" :id="`option_0_` + option.tag_text" @change="searchChanged()">
          <label class="btn first-btn1 text-center d-flex flex-column f14-l18" :for="`option_0_` + option.tag_text">
            <SvgImage :src="option.icon" style="height:50px; width:90px;" />
            {{option.text}}
          </label>
          <div class="first-btn1-check-circle" />
          <img src="@/assets/icons/check-selected.png" class="first-btn1-check-mark" />
        </div>
      </HorizontalScrollContainer>
      <HorizontalScrollContainer v-if="data.selectors.form.bottom_line" class="margin-lr--20 dmargin-lr-0 padding-tb-10 bg-f3"  :centerObjects="data.selectors.form.bottom_line.groups.length <= 2" allowOverflow >
        <FormFilterTagsWithButtonComponent v-for="(group, idx) in data.selectors.form.bottom_line.groups" :key="`group_`+idx" :field="group" :button="data.selectors.form.submit" :group_id="'group_'+idx" :group_index="idx" @selectorChanged="updateSelectors"/>  
        <!-- <div class="w-auto btn second-btn-wrapper f13-l16-l df16-l20 position-relative" style="padding-top: 2px;" v-for="option in data.selectors.form.fields[1].options" :key="option.val">
          <input type="checkbox" name="f1" class="btn-check" autocomplete="off" :value="option.val" v-model="selector1" :id="`option_1_` + option.tag_text" @change="searchChanged()">
          <label class="btn first-btn1 text-center d-flex flex-column f14-l18" :for="`option_1_` + option.tag_text">{{option.text}} </label>
          <img src="@/assets/icons/check-selected.png" class="first-btn1-check-mark" />
        </div> -->
      </HorizontalScrollContainer>
      <form :action="data.selectors.form.submit.href" ref="searchFilter" method="GET">
        <input type="hidden" v-if="data?.selectors.form.top_line.fields" v-model="selector0" :name="data?.selectors.form.top_line.fields[0].data_name" />
        <input type="hidden" v-if="data?.selectors.form.bottom_line?.groups" v-model="selector1String" :name="data?.selectors.form.bottom_line.groups[0].data_name" />
        <!-- <input type="hidden" v-if="data.selectors.form.bottom_line.groups" v-model="selector1" :name="data.selectors.form.bottom_line.groups[0].data_name"> -->
      </form>

    </div>
    <SectionImageComponent v-if="data?.header?.banner" :image="$responsive(data.header.banner)?.image" class="margin-top-20 mw" />
    <LoadingWrapper v-show="loadingInnerFetch" :loading="loadingInnerFetch" style="position:fixed; top:0; left:0;width:100%; height:100%; z-index:1000;" clz="center"></LoadingWrapper>
    <div v-if="data.header" class="margin-top-20 mw">
      <div class="f20-l30-sb df26-l30-b red-link text-center margin-bottom-20 deals_promtion" v-if="data.header.deals_promotion" v-html="data.header.deals_promotion.text"></div>
      <div >
        <span v-html="data.header.title_html" class="f22-l30-b" dir="rtl" />
        <span v-if="data.selectors.form.reset_filter" class="red-link f20-l30-sb"><a href="#" @click.stop.prevent="reset_filter" >{{ data.selectors.form.reset_filter.text  }}</a></span>
      </div>
      <div v-if="data.header.special_tags_html" class="f22-l30-b" dir="rtl" v-html="data.header.special_tags_html" />
      <div class="flex-wrap items-nowrap f20-l30-m df26-l30-m red-link" v-html="data.header.summary_title_html" dir="rtl" />
      <div class="d-flex flex-row margin-top-20">
        <div class="flex-grow-1 f20-l30-sb df26-l30-b">
          {{data.header.results_count.count}} {{data.header.results_count.type}}
        </div>
        </div>
        <div class="d-flex flex-row">
        <form v-if="data.header.sort_selector" class="formfield-round-border small-form f20-l20 df22-l14 search-sort" ref="sortForm" :action="data.header.sort_selector.form.submit.href" method="post">
          <FormFieldComponent class="select-pointer" v-for="(field,idx) in data.header.sort_selector.form.fields" :key="idx" :field="field" @change="sortChanged" />
        </form>

      </div>

    </div>

    <div v-if="data.empty_results" class="mw">
      <div class="f22-l30-b" v-html="data.empty_results.title" dir="rtl" />
      <div class="d-flex flex-row flex-wrap items-nowrap f20-l30-m" v-html="data.empty_results.text_html" dir="rtl" />
    </div>

    <div class="row mw">
      <span class="col-12 col-xl-4 col-md-6" v-for="p in results" :key="p.result_kind + p.result_id">
        <CookCardComponent v-if="p.result_kind=='cook'" :result="p" />
        <CookDishCardComponent v-else-if="p.result_kind=='dish'" :dish="p.result" />
      </span>
    </div>

    <div v-if="haveAlternattiveResults" class="row mw">
      <HorizontalSplitter type="red_bold" class="margin-top-20"/>

      <div class="f22-l30-b margin-top-20" v-html="data.results.alternative_results.title" dir="rtl" />
      <div class="flex-wrap items-nowrap f20-l30-m df26-l30-m red-link" v-html="data.results.alternative_results.description" dir="rtl" />

      <span class="col-12 col-xl-4 col-md-6" v-for="p in alternativeResults" :key="p.result_kind + p.result_id">
        <CookCardComponent v-if="p.result_kind=='cook'" :result="p" />
        <CookDishCardComponent v-else-if="p.result_kind=='dish'" :dish="p.result" />
      </span>
    </div>


    <div v-if="haveMore" class="w-100 mw">
      <form :action="moreResults.form.submit.href" method="post" ref="fetchMore">
        <FormFieldComponent v-for="(field,idx) in moreResults.form.fields" :key="idx" :field="field" />
        <ButtonComponent :caption="moreResults.form.submit.text" @click="fetchMore" @keyup.enter="fetchMore" class="margin-top-20" />
      </form>
    </div>

    <SelectCityTimedComponent :delay="data?.pop_city_select" />
    <!-- </div> -->
  </LoadingWrapper>
</template>
<script>
// import {ref, watch} from "vue";
import {useRoute} from 'vue-router'
import {fetch3, formSubmit} from '@/modules/configuration.js'
import SectionImageComponent from "@/components/generic/SectionImageComponent.vue";
import CookCardComponent from "@/components/search/CookCardComponent.vue"
import FloatingBarComponent from "@/components/search/FloatingBarComponent.vue"
import CookDishCardComponent from "@/components/CookDishCardComponent.vue"
import LoadingWrapper from '@/components/LoadingWrapper.vue'
import SelectCityTimedComponent from '@/components/SelectCityTimedComponent.vue';
import HorizontalScrollContainer from "@/components/generic/HorizontalScrollContainer.vue";
import SvgImage from "@/components/generic/SvgImage";
import FormFieldComponent from "@/components/form/FormFieldComponent";
import ButtonComponent from "@/components/form/ButtonComponent";
import HorizontalSplitter from "@/components/generic/HorizontalSplitter.vue";
import {addGoogleAnalyticsDataLayer} from '@/modules/configuration.js';
import FormFilterTagsWithButtonComponent from '@/components/form/FormFilterTagsWithButtonComponent.vue'

export default {
  components: {
    FloatingBarComponent,
    SectionImageComponent,
    CookCardComponent,
    CookDishCardComponent,
    LoadingWrapper,
    SelectCityTimedComponent,
    HorizontalScrollContainer,
    SvgImage,
    FormFieldComponent,
    ButtonComponent,
    HorizontalSplitter,
    FormFilterTagsWithButtonComponent
  },
  data() {
    return {
      loading: true,
      loadingInnerFetch: false,
      selector0: [],
      selector1: [],
      data: {},
      haveMore: false,
      moreResults: {},
      results: [],
      alternativeResults: [],
      haveAlternattiveResults: false,
      floatingBarData: {}
    }
  },
  mounted() {
    const route = useRoute();
    this.getData(route.fullPath, false, false);
  },
  watch: {
    $route(to) {
      //console.log("route changed to:", to);
      const fullPath = to.fullPath;
      if (fullPath && fullPath.startsWith('/search') && fullPath.indexOf("#") < 0) {
        this.getData(to.fullPath, false, true);
      }

    },
  },
  computed: {
    selector1String() {
      // console.log("selector1String", this.selector1 );
      const filteredValues = this.selector1.filter(val => val !== '');
      // console.log("filtered values: " + filteredValues);
      const result = filteredValues.length > 0 ? filteredValues.join(',') : '';
      // console.log("result: " + result);
      return result.replace(/^,|,$/g, '');
    },
  },
  methods: {
    sortChanged(ev) {
      if (!ev) return;
      if (ev.type == 'change') {
        // window.dataLayer.push({
        //   'sort_value': ev.target.value
        // });
        // console.log("sortchanged");
        this.searchChanged();
      }
    },
    async getData(baseUrl, addToHistory, addDataLayer) {
      this.loadingInnerFetch = true;
      const data = await fetch3(this, {
        url: baseUrl,
        addQueryString: false,
        pushHistory: addToHistory
      });
      // console.log("getDate");
      this.data = data;
      this.loading = false;
      this.loadingInnerFetch = false;
      this.haveMore = data?.results?.have_more_results;
      this.moreResults = data?.results?.more_results;
      this.results = data?.results?.inner?.results || [];
      this.haveAlternattiveResults = data?.results?.have_alternative_results;
      this.alternativeResults = data?.results?.alternative_results?.results;

      let selector0value = data?.selectors?.form?.top_line.fields[0].value || '';
      this.selector0 = selector0value ? selector0value.split(',') : [];

      // let selector1value = data?.selectors?.form?.bottom_line?.groups.fields?.value || '';
      // this.selector1 = selector1value ? selector1value.split(',') : [];

      if (this.data?.selectors.form?.bottom_line?.groups) {
        this.data.selectors.form.bottom_line.groups.forEach((group, index) => {
          this.selector1[index] = group.value;
        });
        if (this.data?.selectors.form?.additional_filters) {
          this.selector1[this.data.selectors.form.bottom_line.groups.length] = this.data.selectors.form.additional_filters;
        }
      }
      
      this.floatingBarData = data?.floating_bar.form || [];

      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

      if (addDataLayer && (this.selector0.length > 0 || (this.selector1.some(str => str.length > 0) ) ) ){
        this.$nextTick(() => {
          const customDataLayer = this.data.data_layer;
          addGoogleAnalyticsDataLayer(customDataLayer);
        });
      }

    },
    async fetchMore(/*url*/) {
      this.loadingInnerFetch = true;
      const form = this.$refs.fetchMore;
      const response = await formSubmit(this, form);
      this.results = [...this.results, ...response.results.inner.results];
      this.haveMore = response.results.have_more_results;
      this.moreResults = response.results.more_results;
      this.loadingInnerFetch = false;
    },
    searchChanged() {
      // this.getData(this.data.selectors.form.submit.href, true);
      // console.log("searchChanged");
      const formData = new FormData(this.$refs.searchFilter);
      const queryString = new URLSearchParams(formData).toString();
      const sortFormData = this.$refs.sortForm && new FormData(this.$refs.sortForm);
      const sortQueryString = this.$refs.sortForm ? new URLSearchParams(sortFormData).toString() : "";
      const url = this.data.selectors.form.submit.href;
      const hasQueryString = url.indexOf('?') > 0;
      const link = url + (hasQueryString ? '&' : '?') + queryString + "&" + sortQueryString;
      // console.log("link: ", link);
      this.$router.push(link);
    },
    updateSelectors(selectorIndex, values) {
      // console.log("updating selectors with " + values);
      // console.log("updating selectors with selectorIndex " +  parseInt(selectorIndex, 10));
      const parsedValues = values.split(',');

      // console.log("parsed values ", parsedValues);
      // console.log(typeof this.selector1);
      this.selector1[parseInt(selectorIndex, 10)] =  parsedValues;
      // console.log("updating selectors selector1 ",  this.selector1);
      // this.selector1String = this.selector1.join(",");
      // console.log("FINISH updating selectors with ", values);
      this.$nextTick(() => {
        this.searchChanged();
      });
    },
    reset_filter(){
      this.selector0 = [];
      this.selector1 = [];
      this.$nextTick(() => {
        this.searchChanged();
      });

    }
  },
}
</script>
<style scoped>
.preference {
  /* border: 1px solid #bbbaba; */
  /* border-radius: 20px;
  background: white; */
  margin: 0 5px;
  display: inline-block;
  text-align: center;
  color: #171717;
  text-decoration: none;
  padding: 0 5px 0 5px;
}

.first-btn1 {
  border: 1px solid #bbbaba;
  border-radius: 5px;
  background: white;
  margin: 0 5px;
  display: inline-block;
  text-align: center;
  color: #171717;
  text-decoration: none;
  padding-right: 20px;
}

.btn-check:checked + .first-btn1 {
  color: #ef3d49;
  border-color: #ef3d49;
  background-color: #f9f9f9;
  padding-right: 20px;
}

.first-btn1-check-mark {
  position: absolute;
  top: 12px;
  right: 10px;
  width: 12px;
  height: 12px;

  display: none;
}

.first-btn1-check-circle {
  position: absolute;
  top: 12px;
  right: 10px;
  width: 12px;
  height: 12px;
  border: 1px solid #D5D5D5;
  border-radius: 50%;
  opacity: 1;
  display: block;
}

.btn-check:checked ~ .first-btn1-check-mark {
  display: block;
}

.btn-check:checked ~ .first-btn1-check-circle {
  display: none;
}


.first-btn-wrapper {
  padding: 0;
}

.second-btn-wrapper {
  padding: 0;
}

.second-btn-wrapper .first-btn1 {
  border-radius: 20px;
  padding-left: 20px;
}

.second-btn-wrapper .first-btn1-check-mark {
  left: 10px;
  right: auto;
}

.small-form .padding-10 {
  padding: 0;
}

.small-form .form-group {
  margin: 0 0 !important;
}

.small-form .col-12 {
  /* width: 0; */
  flex: inherit;
}

.small-form .formselect {
  padding: 0 !important;
}

.small-form .formfield-margin-wrapper {
  margin: 0;
}
.deals_promtion{
  border: 5px solid #ef3d49;
  border-radius: 30px;
  padding: 10px 0px 10px 0px;
}
</style>
